import { render, staticRenderFns } from "./BirthYearDisplayText.vue?vue&type=template&id=492acf18&scoped=true"
import script from "./BirthYearDisplayText.vue?vue&type=script&lang=js"
export * from "./BirthYearDisplayText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "492acf18",
  null
  
)

export default component.exports